import { render, staticRenderFns } from "./DropdownClick.vue?vue&type=template&id=be122b76&"
import script from "./DropdownClick.vue?vue&type=script&lang=js&"
export * from "./DropdownClick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports